/**
 * Maps "how you feel today" to activity / plan intensity.
 * Supports single feeling or multi-select (most restrictive wins).
 */

const FEELING_TO_ACTIVITY = {
  energetic: 'high',
  motivated: 'moderate',
  good: 'moderate',
  okay: 'light',
  sleepy: 'sedentary',
  tired: 'sedentary',
  sore: 'light',
  stressed: 'light',
  anxious: 'light',
};

/** Lower index = more restrictive for today's plan intensity. */
const FEELING_PRIORITY = [
  'tired',
  'sore',
  'anxious',
  'stressed',
  'sleepy',
  'okay',
  'good',
  'motivated',
  'energetic',
];

export const FEELING_OPTIONS = [
  { key: 'energetic', labelKey: 'feeling.energetic' },
  { key: 'motivated', labelKey: 'feeling.motivated' },
  { key: 'good', labelKey: 'feeling.good' },
  { key: 'okay', labelKey: 'feeling.okay' },
  { key: 'sleepy', labelKey: 'feeling.sleepy' },
  { key: 'tired', labelKey: 'feeling.tired' },
  { key: 'sore', labelKey: 'feeling.sore' },
  { key: 'stressed', labelKey: 'feeling.stressed' },
  { key: 'anxious', labelKey: 'feeling.anxious' },
];

/**
 * @param {string|string[]} feelingOrFeelings
 * @returns {string}
 */
export function normalizeFeelings(feelingOrFeelings) {
  const list = Array.isArray(feelingOrFeelings)
    ? feelingOrFeelings
    : feelingOrFeelings
      ? [feelingOrFeelings]
      : [];
  const allowed = new Set(FEELING_OPTIONS.map((o) => o.key));
  return [...new Set(list.map((f) => String(f || '').trim()).filter((f) => allowed.has(f)))];
}

/**
 * @param {string|string[]} feelingOrFeelings
 * @returns {string}
 */
export function pickPrimaryFeeling(feelingOrFeelings) {
  const list = normalizeFeelings(feelingOrFeelings);
  if (list.length === 0) return 'good';
  let best = list[0];
  let bestIdx = FEELING_PRIORITY.indexOf(best);
  if (bestIdx < 0) bestIdx = FEELING_PRIORITY.length;
  for (const f of list) {
    const idx = FEELING_PRIORITY.indexOf(f);
    if (idx >= 0 && idx < bestIdx) {
      best = f;
      bestIdx = idx;
    }
  }
  return best;
}

/**
 * @param {string|string[]} feelingOrFeelings
 * @returns {'sedentary'|'light'|'moderate'|'high'}
 */
export function activityFromFeeling(feelingOrFeelings) {
  const primary = pickPrimaryFeeling(feelingOrFeelings);
  return FEELING_TO_ACTIVITY[primary] || 'light';
}
